import { SET_IS_DEBUG } from "./consts";

const initialState = {
    isDebug: false,
};

export default function devTools(state = initialState, action) {
    switch (action.type) {
        case SET_IS_DEBUG:
            return { ...state, isDebug: action.payload };
        default:
            return state;
    }
}
